import type {
  HirerAccount,
  HirerAccountAction,
} from 'src/app/state/types/hirerAccount';
import { BillingStatus, HirerAccountStatus } from 'src/graphql/generated';

const defaultState: HirerAccount = {
  billingStatus: BillingStatus.OK,
  hasAgent: false,
  hasLinkOutEnabled: false,
  hidePrice: false,
  hirerType: undefined,
  isApproved: false,
  isEsmAccount: false,
  isPrivateAdvertiser: false,
  nation: '',
  pricingModel: undefined,
  pricingGroupContractExists: false,
  rules: undefined,
  status: HirerAccountStatus.ACTIVE,
};

const RESET = 'session/hirerAccount/RESET';
const UPDATE = 'session/hirerAccount/UPDATE';

export const actionResetHirerAccount = () => ({
  type: RESET,
});

export const actionUpdateHirerAccount = (value: HirerAccount) => ({
  type: UPDATE,
  value,
});

export default (
  state: HirerAccount = defaultState,
  action: HirerAccountAction,
) => {
  switch (action.type) {
    case RESET: {
      return defaultState;
    }
    case UPDATE: {
      return action.value;
    }
    default: {
      return state;
    }
  }
};

export const forTest = {
  defaultState,
  RESET,
  UPDATE,
};
